import {
  OrderDetailStatus,
  OrderDetailViewModel,
  OrderStatus
} from '@/api/api';
import AuthStorageService from '../account/auth.storage.service';

export interface ValidateResult {
  isValid: boolean;
  message?: string;
}

export function validateOrderDetails(
  orderStatus: OrderStatus,
  orderDetails: OrderDetailViewModel[]
) {
  const hasFullPermission = AuthStorageService.isFullPermission();
  if (AuthStorageService.isProducingPermission()) {
    // this.$bvToast.toast('Bạn không có quyền sửa đơn hàng', {
    //   title: this.$t('Order').toString(),
    //   toaster: 'b-toaster-bottom-right',
    //   variant: 'danger'
    // });
    return { isValid: false, message: 'Bạn không có quyền sửa đơn hàng' };
  }

  const inValidToUpdate =
    orderStatus === OrderStatus.Delivered &&
    orderDetails.findIndex((s) => s.status !== OrderDetailStatus.Delivered) ===
      -1;
  if (inValidToUpdate && !hasFullPermission) {
    // this.$bvToast.toast('Không thể chỉnh sửa đơn hàng đã hoàn thành', {
    //   title: this.$t('Order').toString(),
    //   toaster: 'b-toaster-bottom-right',
    //   variant: 'danger'
    // });

    return {
      isValid: false,
      message: 'Không thể chỉnh sửa đơn hàng đã hoàn thành'
    };
  }

  return { isValid: true, message: '' };
}
